window.app = window.app || {};

window.app.vertCarousel = {
  el: {
    navigation: document.querySelector('.mt-vert-carousel__navigation'),
    navigationItems: document.querySelectorAll('.mt-vert-carousel__navigation a'),
    carousel: document.querySelector('.mt-vert-carousel__carousel .swiper')
  },

  init: function() {
    const _this = this;
    if (!_this.el.carousel) return;

    _this.slider = new Swiper(_this.el.carousel, {
      slidesPerView: 1,
      spaceBetween: 0,
      loop: true,
      pagination: {
        el: '.swiper-pagination',
        clickable: true
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      breakpoints: {
        1200: {
          spaceBetween: -36
        }
      }
    });

    if (_this.el.navigation && _this.el.navigationItems.length > 0) {
      _this.el.navigationItems.forEach(item => {
        item.addEventListener('click', e => { 
          e.preventDefault();
          const slide = _this.el.carousel.querySelector(`.mt-vert-carousel-item[data-slide-id='${item.dataset.slide}']`).closest('.swiper-slide');
          slide && _this.slider.slideTo(Array.from(slide.parentNode.children).indexOf(slide));
          (window.innerWidth < 768) && item.closest('li').scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        })
      });
      _this.slider.on('slideChangeTransitionStart', () => {
        const slide = _this.el.carousel.querySelector('.swiper-slide-active .mt-vert-carousel-item');
        _this.el.navigationItems.forEach(item => {
          if (item.dataset.slide == slide.dataset.slideId) {
            item.classList.add('active');
            (window.innerWidth < 768) && item.closest('li').scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
          } else {
            item.classList.remove('active');
          }
        });
      });
    }
  }
}
window.app.vertCarousel.init();